import { setCookie, v as bvVar } from 'bv';
import { routing as routingSelectors } from 'redux-selectors';

const { makeIsCurrentPath } = routingSelectors;
const isCurrentPath = makeIsCurrentPath();

const dimensionProductIds = bvVar('dimensionProductIds');
const productNames = Object.keys(dimensionProductIds);

const getProductName = (state) => productNames.find((productName) => isCurrentPath(state, `/${productName}`));

const getDimensionId = (state) => dimensionProductIds[getProductName(state)];

const setProductIdCookie = (state) => {
  const dimensionId = getDimensionId(state);
  if (dimensionId) {
    setCookie('product_id', dimensionId);
  }
};

export default setProductIdCookie;
